
import { defineComponent } from 'vue';
import ReadMore from '@/components/ReadMore.vue';

export default defineComponent({
  name: 'PublicationsTable',
  components: {
    ReadMore
  },
  props: {
    msg: String,
    items: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      sortColumn: 'year',
      sortOrder: 'desc',
      tableColumns: [
        { key: 'year', name: 'Year' },
        { key: 'title', name: 'Title' },
        { key: 'authors', name: 'Authors' },
        { key: 'project', name: 'Project' },
        { key: 'journal', name: 'Publication' },
        { key: 'media', name: 'Media' },
      ],
      isMobile: false
    }
  },
  mounted () {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },
  methods: {
    onResize () {
      this.isMobile = window.innerWidth <= 920
    },
    onSortTable(key: string)
    {
      if(key == 'media') {
        return;
      }

      if(this.sortColumn != key) {

        /** Default to ascending order for A-Z fields */
        if(['title', 'project', 'authors', 'journal'].includes(key)) {
          this.sortOrder = 'asc';
        } else {
          this.sortOrder = 'desc';
        }

      } else {
        this.sortOrder = this.sortOrder === 'desc' ? 'asc' : 'desc';
      }

      this.sortColumn = key;
      this.$emit('sortChange', this.sortColumn, this.sortOrder);
    },
  }
});
